module.exports = __webpack_public_path__ + "static/media/piggy-bank.acd3dbbf.svg";